import { IS_BROWSER } from '$fresh/runtime.ts'
import { useEffect } from 'preact/hooks'
import { getAlgoliaUserTokenFromDocument } from 'site/utils/algoliaUserToken.ts'

interface WindowWithDataLayer extends Window {
    dataLayer?: Record<string, unknown>[]
}

export default function AlgoliaUserToken() {
    if (!IS_BROWSER) return null

    useEffect(() => {
        const userToken = getAlgoliaUserTokenFromDocument()
        if (!userToken) return

        const w = globalThis.window as WindowWithDataLayer
        w.dataLayer = w.dataLayer ?? []
        w.dataLayer.push({ algoliaUserToken: userToken })
    }, [])

    return null
}
